<div class="auth-container">
  <!-- Animated Background -->
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <div class="gradient-orb gradient-orb-3"></div>

    <!-- Floating Particles -->
    <div class="particles">
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
    </div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <!-- Top bar: Brand + Theme-Toggle -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="../../../../../assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- 403 Error Code -->
      <div class="error-code-wrapper">
        <h1 class="error-code">403</h1>
      </div>

      <!-- Security Shield Icon -->
      <div class="shield-container">
        <div class="shield-icon">
          <i class="fa-light fa-shield-xmark"></i>
        </div>
      </div>

      <!-- Error Message -->
      <h2 class="error-title">{{ "ACCESS_DENIED" | translate }}</h2>
      <p class="error-description">
        {{ "ACCESS_DENIED_DESCRIPTION" | translate }}
      </p>

      <!-- Access Details -->
      <div class="access-details">
        <div class="detail-item">
          <i class="fa-light fa-circle-exclamation"></i>
          <span>
            <span class="detail-label">{{ "ERROR_CODE" | translate }}:</span>
            403 Forbidden
          </span>
        </div>
        <div class="detail-item">
          <i class="fa-light fa-user-lock"></i>
          <span>
            <span class="detail-label">{{ "REASON" | translate }}:</span>
            {{ "INSUFFICIENT_PERMISSIONS" | translate }}
          </span>
        </div>
        <div class="detail-item" *ngIf="attemptedRoute">
          <i class="fa-light fa-route"></i>
          <span>
            <span class="detail-label"
              >{{ "REQUESTED_PAGE" | translate }}:</span
            >
            {{ attemptedRoute }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <xds-button
          variant="secondary"
          [block]="true"
          iconLeft="fa-light fa-arrow-left"
          (clicked)="goBack()"
        >
          {{ "GO_BACK" | translate }}
        </xds-button>

        <xds-button
          variant="primary"
          [block]="true"
          iconLeft="fa-light fa-house"
          (clicked)="goToDashboard()"
        >
          {{ "GO_TO_DASHBOARD" | translate }}
        </xds-button>
      </div>

      <!-- Help Footer -->
      <div class="form-footer">
        <p class="footer-text">
          {{ "NEED_HELP_QUESTION" | translate }}
          <a class="link-text" (click)="contactSupport()">
            {{ "CONTACT_SUPPORT" | translate }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
